import { createFileRoute } from "@tanstack/react-router";
import { IncreaseBanking } from "@/components/IncreaseBanking";

function RouteComponent() {
  return <IncreaseBanking />;
}

export const Route = createFileRoute("/_authenticated/increase-banking/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
